import PropTypes from "prop-types";
import React, { useEffect, useState, useRef, useCallback } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import Utils from "../../pages/Utility";
import { get } from "../../helpers/api_helper";

//i18n
import { useTranslation, withTranslation } from "react-i18next";

// redux
import { connect } from "react-redux";
import { getNotiSuccess, profileSuccess } from "../../store/actions";

const SidebarContent = (props) => {
  // console.log('props on slidebar content', props);
  const { t } = useTranslation();
  const [subMenu, setSubMenu] = useState(false);
  const [isModerator, setIsModerator] = useState(false);
  const [isDealer, setIsDealer] = useState(false);
  const [isAutoLead, setIsLeadAuto] = useState(false);

  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname, props?.user?.role]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    item.style.color = Utils.themeColor;
    item.style.fontWeight = "bold";
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }
  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    let user = JSON.parse(await localStorage.getItem("user"));
    // console.log('side bar', user)
    props.profileSuccess(user);
  };

  return (
    <React.Fragment>
      <SimpleBar ref={ref} className="vertical-simplebar">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i
                  className="mdi mdi-airplay"
                  style={{ color: Utils.themeColor }}
                ></i>
                <span>{t("Dashboard")}</span>
              </Link>
            </li>
            {/* {props.user?.role == "Admin" && ( */}
            <>
              <li>
                <Link
                  to={"/#"}
                  className={"has-arrow waves-effect"}
                  onClick={() => setSubMenu(!subMenu)}
                >
                  <i
                    className="mdi mdi-forum"
                    style={{ color: Utils.themeColor }}
                  ></i>
                  <span>{t("Tender Master")}</span>
                </Link>
                <ul className={"sub-menu"}>
                  <li>
                    <Link to="/tender-master">{t("Add Tender ")}</Link>
                  </li>
                  <li>
                    <Link to="/View-Tender">{t("View Tender")}</Link>
                  </li>
                  <li>
                    <Link to="/archive-tender">{t("Tender Archived")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  to={"/#"}
                  className={"has-arrow waves-effect"}
                  onClick={() => setSubMenu(!subMenu)}
                >
                  <i
                    className="mdi mdi-forum"
                    style={{ color: Utils.themeColor }}
                  ></i>

                  <span>{t("Job Master")}</span>
                </Link>
                <ul className={"sub-menu"}>
                  <li>
                    <Link to="/job-master">{t("Add Job")}</Link>
                  </li>
                  <li>
                    <Link to="/view-Job">{t("View Job")}</Link>
                  </li>
                  <li>
                    <Link to="/archive-job">{t("Job Archived")}</Link>
                  </li>
                </ul>
              </li>
              {/* <li>
                  <Link to="/language" className="waves-effect">
                    <i
                      className="mdi mdi-translate"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Languages")}</span>
                  </Link>
                </li> */}
              <li>
                <Link
                  to={"/#"}
                  className={"has-arrow waves-effect"}
                  onClick={() => setSubMenu(!subMenu)}
                >
                  <i
                    className="mdi mdi-forum"
                    style={{ color: Utils.themeColor }}
                  ></i>
                  <span>{t("News Master")}</span>
                </Link>
                <ul className={"sub-menu"}>
                  {/* <li><Link to="/quotes/tags">{t("Tags")}</Link></li> */}
                  <li>
                    <Link to="/news-master">{t("Add News")}</Link>
                  </li>
                  <li>
                    <Link to="/View-news">{t("View News")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to={"/inquiry-master"}>
                  <i
                    className="mdi mdi-phone-in-talk"
                    style={{ color: Utils.themeColor }}
                  ></i>
                  <span>{t("Inquiry Master")}</span>
                </Link>
                {/* <ul className={"sub-menu"}>
                    <li>
                      <Link to="/weather">{t("Weather")}</Link>
                    </li>
                    <li>
                      <Link to="/theme">{t("Theme")}</Link>
                    </li>
                  </ul> */}
              </li>
              <li>
                <Link to="/last-update" className="waves-effect">
                  <i
                    className="mdi mdi-bell-ring-outline"
                    style={{ color: Utils.themeColor }}
                  ></i>
                  <span>{t("Last Update")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"/#"}
                  className={"has-arrow waves-effect"}
                  onClick={() => setSubMenu(!subMenu)}
                >
                  <i
                    className="mdi mdi-table"
                    style={{ color: Utils.themeColor }}
                  ></i>
                  <span>{t("Contact-us")}</span>
                </Link>
                <ul className={"sub-menu"}>
                  {/* <li><Link to="/quotes/tags">{t("Tags")}</Link></li> */}
                  <li>
                    <Link to="/contact-table">{t("Table")}</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">{t("Member")}</Link>
                  </li>
                </ul>
              </li>
              {/* <li>
                <Link to="/contact-us" className="waves-effect">
                  <i
                    className="mdi mdi-table"
                    style={{ color: Utils.themeColor }}
                  ></i>
                  <span>{t("Contact-us")}</span>
                </Link>
              </li> */}
              {/* <li>
                  <Link
                    to={"/#"}
                    className={"has-arrow waves-effect"}
                    onClick={() => setSubMenu(!subMenu)}
                  >
                    <i
                      className="mdi mdi-soundcloud"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Harmony")}</span>
                  </Link>
                  <ul className={"sub-menu"}>
                    <li>
                      <Link to="/harmony_mood">{t("Mood")}</Link>
                    </li>
                    <li>
                      <Link to="/harmony_category">
                        {t("Sound Category")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/harmony_sound">{t("Sounds")}</Link>
                    </li>
                  </ul>
                </li> */}
              {/* <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i
                      className="mdi mdi-account-star"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Know Yourself")}</span>
                  </Link>
                  <ul className={"sub-menu"}>
                    <li>
                      <Link to="/know-yourself-category">
                        {t("Category")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/know-yourself-intro">
                        {t("Introduction")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/know-yourself-question">
                        {t("Questions")}
                      </Link>
                    </li>
                  </ul>
                </li> */}
              {/* <li>
                  <Link to="/category" className="waves-effect">
                    <i
                      className="mdi mdi-shape"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Category")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/tags" className="waves-effect">
                    <i
                      className="mdi mdi-tag-multiple"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Tags")}</span>
                  </Link>
                </li> */}
              {/* <li>
                  <Link to="/store" className="waves-effect">
                    <i
                      className="mdi mdi-image-multiple"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Image Store")}</span>
                  </Link>
                </li> */}
              {/* <li>
                  <Link to="/content" className="waves-effect">
                    <i
                      className="mdi mdi-table-of-contents"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Content")}</span>
                  </Link>
                </li> */}
              {/* <li>
                  <Link to="/games" className="waves-effect">
                    <i
                      className="mdi mdi-gamepad"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Games")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/communities" className="waves-effect">
                    <i
                      className="mdi mdi-home-group"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Communities")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i
                      className="mdi mdi-account-star"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Talk To Me")}</span>
                  </Link>
                  <ul className={"sub-menu"}>
                    <li>
                      <Link to="/talk-intro">{t("Introduction")}</Link>
                    </li>
                    <li>
                      <Link to="/talk-category">{t("Category")}</Link>
                    </li>
                    <li>
                      <Link to="/talk-ques">{t("Question")}</Link>
                    </li>
                    <li>
                      <Link to="/talks">{t("Sessions")}</Link>
                    </li>
                  </ul>
                </li> */}
              {/* <li>
                  <Link to="/live_session" className="waves-effect">
                    <i
                      className="mdi mdi-youtube-tv"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Live Session")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i
                      className="mdi mdi-cast-audio"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Podcast")}</span>
                  </Link>
                  <ul className={"sub-menu"}>
                    <li>
                      <Link to="/podcast">{t("Podcasts")}</Link>
                    </li>
                    <li>
                      <Link to="/podcast_request">
                        {t("Podcast Request")}
                      </Link>
                    </li>
                  </ul>
                </li> */}
              {/* <li>
                  <Link to="/podcast" className="waves-effect">
                    <i className="mdi mdi-cast-audio" style={{ color: Utils.themeColor }}></i>
                    <span>{t("Podcast Request")}</span>
                  </Link>
                </li> */}
              {/* <li>
                  <Link to="/plans" className="waves-effect">
                    <i
                      className="mdi mdi-currency-usd"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Plans")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/coupon" className="waves-effect">
                    <i
                      className="mdi mdi-ticket-percent"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Coupon")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/social-media" className="waves-effect">
                    <i
                      className="mdi mdi-play-network"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Social-Media")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/setting" className="waves-effect">
                    <i
                      className="mdi mdi-cogs"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Settings")}</span>
                  </Link>
                </li> */}
              {/* <li>
                  <Link to="/screen" className="waves-effect">
                    <i
                      className="mdi mdi-cellphone-text"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("App Screens")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/notification" className="waves-effect">
                    <i
                      className="mdi mdi-bell"
                      style={{ color: Utils.themeColor }}
                    ></i>
                    <span>{t("Notifications")}</span>
                  </Link>
                </li> */}
            </>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  // console.log('state ', state);
  const user = state.Profile.success;
  return { user };
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  profileSuccess: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, { profileSuccess })(SidebarContent)
);
